import React from 'react'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import { format } from 'd3-format'

const Amount = ({
  value,
  mainCurrency,
  mainCurrencyName,
  svg,
  onClick,
  className,
}) => {
  const numberFormat = format(`,${mainCurrency ? '.2' : ''}f`)
  const text = `${numberFormat(value)}${mainCurrency
    ? `\u00A0${mainCurrencyName}`
    : ''}`
  if (svg) {
    return (
      <tspan className={className} onClick={onClick}>
        {text}
      </tspan>
    )
  } else {
    return (
      <span
        style={{ cursor: onClick ? 'pointer' : null }}
        onClick={onClick}
        className={className}
      >
        {text}
      </span>
    )
  }
}

const mapStateToProps = state => ({
  mainCurrencyName: selectors.mainCurrency(state),
})

export default connect(mapStateToProps)(Amount)



// WEBPACK FOOTER //
// ./src/components/Amount.js